<template lang="pug">
#laudos
    el-upload.upload-demo(
        action='#',
        drag,
        :file-list='fileListPlanilha',
        :limit='1',
        :on-exceed='handleExceed',
        :auto-upload='false',
        :on-change='handleFileChange',
        :on-remove='onRemoveFilePlanilha',
        ref='uploadPlanilhaLaudo'
    )
        i.el-icon-upload
        .el-upload__text.w-100(style='font-size: 16px; color: var(--grey)') {{ $t('mensagens.laudos.arrasteArquivo.1') }} <em>{{ $t('mensagens.laudos.arrasteArquivo.2') }}</em>
        .el-upload__text.w-100(style='color: var(--grey)') {{ $t('mensagens.laudos.arrasteArquivo.4') }}
    .d-flex.flex-direction.justify-content-between.py-3
        BaseButton(slot='footer', size='mini', @click='closeDialog') {{ $t('mensagens.comuns.voltar') }}
        BaseButton(
            v-if='showConfirmar',
            slot='footer',
            size='mini',
            type='primary',
            @click='submit',
            :disabled='anoFinalAnalise===null'
        ) {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import LaudosService from '@/services/LaudosService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'SelecionarArquivoVetorial',

    props: {
        tipoLaudo: {
            type: Number,
            required: true
        },
        anoFinalAnalise: {
            type: String,
            required: false,
            default: null
        }
    },

    emits: ['cancelar-modal', 'checar-upload'],
    components: {
        BaseButton
    },

    data() {
        return {
            showUploadVetorial: false,
            showConfirmar: false,
            arquivoUpload: null,
            fileList: [],
            fileListPlanilha: []
        };
    },

    methods: {
        closeDialog() {
            this.$emit('checar-upload', false);
            this.$emit('cancelar-modal');
            this.limpar();
        },

        async confirmar() {
            if (!this.arquivoUpload) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.uploadDeArquivoObrigatorio'
                    )
                });
                return;
            }

            let arquivoUploadNome = null;
            if (this.arquivoUpload) {
                arquivoUploadNome = [];
                arquivoUploadNome.push(this.arquivoUpload.nomeArquivo);
            }

            const informacao = {
                nomeArquivos: arquivoUploadNome,
                tipoLaudoId: this.tipoLaudo,
                tipoInsumo: 'ARQUIVO_XLSX',
                anoFimAnalise: this.anoFinalAnalise
            };
            const informacaoLaudos = [];
            informacaoLaudos.push(informacao);

            try {
                await LaudosService.cadastrarLaudos({ informacaoLaudos });

                this.closeDialog();

                this.$notify.success({
                    message: this.$t(
                        'mensagens.laudos.solicitacaoRealizadaComSucesso'
                    )
                });

                this.atualizarTabela();
            } catch (e) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.erro.erroAoCadastrarLaudo'
                    )
                });
            }
        },

        handleFileChange(file, fileList) {
            const isXlsx = file.name.endsWith('.xlsx');
            if (!isXlsx) {
                this.$notify.error('Somente arquivos no formato .xlsx são permitidos.');
                this.fileList = fileList.filter(f => f.name.endsWith('.xlsx'));
                this.showConfirmar = false;
                return;
            }
            this.showConfirmar = true;
            this.fileList = fileList;
        },

        montarPayload() {
            return {
                informacaoLaudos: [
                    {
                        tipoLaudoId: this.tipoLaudo,
                        tipoInsumo: 'ARQUIVO_XLSX',
                        anoFimAnalise: this.anoFinalAnalise
                    }
                ]
            };
        },

        async submit() {
            const payload = this.montarPayload();

            if (this.fileList.length === 0) {
                this.$notify.error(this.$t('mensagens.laudos.anexarArquivoparaContinuar'));
                return;
            }

            const arquivo = this.fileList[0].raw || this.fileList[0];
            
            try {
                await LaudosService.cadastrarLaudoComArquivo(payload, arquivo);
                this.closeDialog();
                this.$notify.success(this.$t('mensagens.laudos.solicitacaoEnviadaComSucesso'));
            } catch (error) {
                let chaveMensagemErro = 'mensagens.laudos.erro.erroAoCadastrarLaudo';
                if (error.response.data === '[ERRO_KEYCLOAK]') {
                    chaveMensagemErro = 'mensagens.laudos.erro.erroAoCadastrarLaudoKeyckoak';
                } else if (error.response.data === '[ERRO_SEM_PERMISSAO]') {
                    chaveMensagemErro = 'mensagens.laudos.erro.erroAoCadastrarLaudoSemPermissao';
                }

                this.$notify.error({
                    message: this.$t(chaveMensagemErro),
                    duration: 15000
                });
            }
        },

        async onRemoveFilePlanilha(file, fileListPlanilha) {
            this.$emit('checar-upload', false);
            this.showConfirmar = false;
            this.arquivoUpload = null;
            this.fileListPlanilha = [];
        },

        handleExceed() {
            this.$notify.warning(this.$t('mensagens.laudos.limiteDeUmArquivo'));
        },

        limpar() {
            this.arquivoUpload = null;
            this.fileListPlanilha = [];
            this.showUploadVetorial = false;
            this.showConfirmar = false;
            this.arquivoUpload = null;
            this.fileList = [];
        }
    }
};
</script>

<style lang="scss" scoped>
#modal-opcoes-laudo {
    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .el-upload,
    .el-upload--text,
    .el-upload-dragger {
        width: 100%;
    }
}
</style>
